<template>
    <Modal>
        <div class="text-center">
            <h2 class="title">EXPORT?</h2>
            <div class="text">Once the trim is exported, further changes won't be allowed.</div>

            <p v-if="errorSend" class="color-red">{{ errorSend }}</p>
        </div>

        <template #footer>
            <Button class="gray" @click="closeModal">Cancel</Button>

            <Button @click="exportConfirmed" :loading="sendStatus">{{ trimEditDisabled ? '' : 'Save and ' }}Export</Button>
        </template>
    </Modal>
</template>

<script>
    import { mapGetters, mapActions } from 'vuex';
    import Modal from "../Modal";
    import Button from "../Button";

    export default {
        name: "ExportTrimModal",

        components: {
            Button,
            Modal
        },

        props: [
            'trimId',
        ],

        data() {
            return {
                sendStatus: false,
                errorSend: null,
            }
        },

        computed: {
            ...mapGetters('editor', [
                'trimEditDisabled',
            ]),

        },

        methods: {
            ...mapActions('trims', [
                'exportTrimFromEditor',
            ]),

            closeModal() {
                this.$emit('closeModal');
            },

            async exportConfirmed() {
                this.sendStatus = true;

                this.exportTrimFromEditor(this.trimId)
                    .then(() => {
                        this.$emit('exportSuccess');
                        this.closeModal();
                    }, (error) => {
                        this.errorSend = error;
                    })
                    .finally(() => {
                        this.sendStatus = false;
                    });
            },

        },

    }
</script>

<style scoped>
    .title {
        margin: 45px 0 60px;
        font-weight: 900;
        color: #880015;
    }

    .text {
        margin: 0 0 25px;
        font-weight: 900;
    }
</style>